import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';

class Goods extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pluginData: PropTypes.object,
    };

    render() {
        const { content, pluginData } = this.props;
        const { id = '' } = content;
        const { goodsPlugin = {} } = pluginData;
        const { goods = [] } = goodsPlugin;
        const goodsData = goods.filter(item => item.id === id)[0] || {};

        return goodsData.id ? (
            <div className={styles.goodsContainer}>
                {goodsData.mobileUrl ? (
                    <a href={goodsData.mobileUrl}>
                        <img src={goodsData.mobilePic} />
                    </a>
                ) : (
                    <img src={goodsData.mobilePic} />
                )}
            </div>
        ) : null;
    }
}

export default Goods;
